/**
 * Off Canvas
 *
 * @module app/components/OffCanvas
 */
import _ from 'lodash';
import jQuery from 'jquery';

/**
 * Initialize OffCanvas
 *
 * @param {Object} element main container wrapping the Off Canvas
 *
 * @returns {void}
 *
 * @private
 */
var init = function (element) {

    // Perform Off Canvas initialisation from Element Data Attributes
    var attrs = getAttrs(element);
    initOffCanvasFromAtrrs(element, attrs);

    // Bind events
    bindEventsTogglePanels(element);
};

/**
 * Initialize Off Canvas from canvas data attributes
 *
 * @param {Object} element OffCanvas wrapper element
 * @param {Object} attrs canvas data attributes
 *
 * @returns {void}
 *
 * @private
 */
var initOffCanvasFromAtrrs = function (element, attrs) {

    // Set Panel Active
    showPanelActive(element, attrs.panelActive);
};

/**
 * Bind events Left and Right Panels toggle and hide click events
 *
 * @param {Object} element OffCanvas wrapper element
 *
 * @returns {void}
 *
 * @private
 */
var bindEventsTogglePanels = function (element) {

    bindEventsToggleLeftPanel(element);
};

/**
 * Binds toggle and hide events for Left Panel
 *
 * @param {Object} element OffCanvas wrapper element
 *
 * @returns {void}
 *
 * @private
 */
var bindEventsToggleLeftPanel = function (element) {

    element.find('.off-canvas__left-toggle')
        .off('click.offCanvasLeftToggle')
        .on('click.offCanvasLeftToggle', toggleLeftPanel.bind(this, element));

    element.find('.off-canvas__left-exit')
        .off('click.offCanvasLeftExit')
        .on('click.offCanvasLeftExit', hideLeftPanel.bind(this, element));
};

/**
 * Get Off Canvas data attributes
 *
 * @param {Object} element canvas wrapper element
 *
 * @returns {Object}
 *
 * @private
 */
var getAttrs = function (element) {

    return {
        panelActive: element.attr('data-panel-active'),
    };
};

/**
 * Toggle Left Panel
 *
 * @param {Object} element canvas wrapper element
 *
 * @returns {Boolean}
 *
 * @private
 */
var toggleLeftPanel = function (element) {

    window.scrollTo(0, 0);
    if (element.hasClass('off-canvas--move-right')) {

        hideLeftPanel(element);
    } else {

        showLeftPanel(element);
    }

    return false;
};

/**
 * Show Left Panel
 *
 * @param {Object} element canvas wrapper element
 *
 * @returns {Boolean}
 *
 * @private
 */
var showLeftPanel = function (element) {

    var offCanvasWrapper = element.closest('.off-canvas__wrapper');
    offCanvasWrapper.addClass('off-canvas--move-right');
    return false;
};

/**
 * Hide Left Panel
 *
 * @param {Object} element canvas wrapper element
 *
 * @returns {Boolean}
 *
 * @private
 */
var hideLeftPanel = function (element) {

    var offCanvasWrapper = element.closest('.off-canvas__wrapper');
    offCanvasWrapper.removeClass('off-canvas--move-right');
    return false;
};

/**
 * Show Left or Right Panel
 *
 * @param {Object} element canvas element
 * @param {String} panel 'left', otherwise will set Right panel active
 *
 * @returns {void}
 *
 * @private
 */
var showPanelActive = function (element, panel) {

    if (panel === 'left') {

        setLeftPanelActive(element, panel);
    }
};

/**
 * Set Left Panel Active
 *
 * @param {Object} element canvas wrapper element
 * @param {String} panel main, left panel string
 *
 * @returns {void}
 *
 * @private
 */
var setLeftPanelActive = function (element, panel) {

    if (panel === 'left') {

        showLeftPanel(element);
    }
};

/**
 * Public functions.
 *
 * @type {Object}
 *
 * @public
 */
var api = {

    /**
     * Initializes OffCanvas component
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        jQuery('#contentarea .off-canvas').each(function () {

            init(jQuery(this));
        });
    },

    /**
     * Shows OffCanvas Left Panel
     *
     * @param {Object} element OffCanvas wrapper element or any element inside wrapper
     *
     * @returns {void}
     *
     * @public
     */
    showLeftPanel: function (element) {

        if (!_.isObject(element)) {

            element = jQuery(element);
        }
        showLeftPanel(element);
    },

    /**
     * Hides OffCanvas Left Panel
     *
     * @param {Object} element OffCanvas wrapper element or any element inside wrapper
     *
     * @returns {void}
     *
     * @public
     */
    hideLeftPanel: function (element) {

        if (!_.isObject(element)) {

            element = jQuery(element);
        }
        hideLeftPanel(element);
    },

    /**
     * Toggles OffCanvas Left Panel
     *
     * @param {Object} element main OffCanvas wrapper element
     *
     * @returns {void}
     *
     * @public
     */
    toggleLeftPanel: function (element) {

        toggleLeftPanel(element);
    },

    /**
     * Binds toggle events for the left panel
     *
     * @param element {Object} - OffCanvas element
     *
     * @returns {void}
     *
     * @public
     */
    bindEventsToggleLeftPanel: function (element) {

        bindEventsToggleLeftPanel(element);
    },

};

export default api;
